import { ReactNode } from "react";
import { Box } from "@mui/material";

import EkocropLogo from "../../../modules/sidebar/ekocrop-logo.svg";

interface InfoPageLayoutProps {
  children: ReactNode;
}

/**
 * Страница без оболочки приложения: до входа или когда работать в приложении нельзя.
 * Логотип — в левом верхнем углу, на месте логотипа сайдбара, чтобы пользователь
 * узнавал продукт, а содержимое — по центру экрана.
 */
export const InfoPageLayout = ({ children }: InfoPageLayoutProps): JSX.Element => (
  <Box
    sx={{
      bgcolor: ({ palette }) => palette.background.default,
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
    }}
  >
    <Box component="header" sx={{ pl: 2, pt: 2 }}>
      <Box
        component="img"
        src={EkocropLogo}
        alt="EkoCrop"
        sx={{ display: "block", height: 64 }}
      />
    </Box>
    <Box
      component="main"
      sx={{
        alignItems: "center",
        display: "flex",
        flex: 1,
        justifyContent: "center",
        pb: 10,
        px: 2,
      }}
    >
      {children}
    </Box>
  </Box>
);
